import type { BookingFactCreateInput } from '@gh/common/models'
import {
  enqueueClinicalBookingFact,
  getClinicalBookingFactsWriteContext,
} from '@/components/consultation/bookingFacts/clinicalBookingFactsContext'
import { writeBookingFact } from '@/components/consultation/bookingFacts/bookingFactsWriter'

export function emitClinicalBookingFact(
  fact: Omit<BookingFactCreateInput, 'id' | 'consultationId' | 'customerId'>,
): void {
  const context = getClinicalBookingFactsWriteContext()
  if (!context) {
    enqueueClinicalBookingFact(fact)
    return
  }
  void writeBookingFact({
    consultationId: context.consultationId,
    customerId: context.customerId,
    fact,
  })
}
